const env = process.env.GATSBY_BUILD_ENV || process.env.NODE_ENV || 'development';
const production = env === 'production';

module.exports = {
  ga: 'UA-120933986-1',
  env,
  production,
  local: !process.env.GATSBY_BUILD_ENV,
};



// WEBPACK FOOTER //
// ./src/config.js